import { inject, Injectable, TemplateRef } from '@angular/core';
import { DsToastService } from '@bmw-ds/components';
import { DsToastModel } from '@bmw-ds/components/ds-interfaces/toast/toast.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastExtendedService {
  private readonly dsToastService = inject(DsToastService);
  private errorTemplate?: TemplateRef<unknown>;
  private errorText?: string;

  public setDefaultErrorTemplate(template: TemplateRef<unknown>) {
    this.errorTemplate = template;
  }

  public getErrorText() {
    return this.errorText ?? '';
  }

  public pushErrorToast(newToast: DsToastModel) {
    this.errorText =
      typeof newToast.toastText === 'string' ? newToast.toastText : '';

    this.dsToastService.pushToast({
      ...newToast,
      toastText: this.errorTemplate ?? '',
    });
  }
}
